var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    {
      staticClass: "bg-red-600 text-white",
      attrs: {
        id: _vm.id,
        fullscreen: _vm.$ui.mobile,
        options: _vm.options,
        scrollable: false
      }
    },
    [
      _c("div", { staticClass: "flex mb-4 items-center" }, [
        _c("h2", { staticClass: "font-semibold text-xl text-red-200" }, [
          _vm._v(" " + _vm._s(_vm.errorName) + " ")
        ]),
        _c("div", { staticClass: "flex-grow" }),
        _c(
          "button",
          {
            staticClass: "p-2 ml-2 -my-2 rounded-lg hover:bg-red-700",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.close(true)
              }
            }
          },
          [
            _c("BaseIcon", {
              staticClass: "w-4 h-4 text-red-200",
              attrs: { name: "close" }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col relative -mx-4 -mb-4 bg-red-200 flex-grow overflow-hidden"
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col relative p-4 desktop:flex-row" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "text-gray-700 leading-relaxed mb-3 desktop:mr-3 desktop:mb-0"
                },
                [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
              ),
              _vm.$ui.desktop
                ? _c("div", { staticClass: "flex-shrink-0 w-40" })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "\n                    flex flex-col\n                    desktop:absolute desktop:right-0 desktop:top-0 desktop:m-4\n                    desktop:flex-row-reverse\n                "
                },
                [
                  _c("ErrorInfoModalButton", {
                    staticClass: "bg-red-200 text-red-800 mb-2 desktop:mb-0",
                    attrs: { icon: "terminal", action: "inspect in console" },
                    on: { click: _vm.inspect }
                  }),
                  _c("ErrorInfoModalButton", {
                    staticClass:
                      "bg-red-200 text-red-800 mb-2 desktop:mr-2 desktop:mb-0",
                    attrs: { icon: "copy", action: "copy to clipboard" },
                    on: { click: _vm.copy }
                  }),
                  _vm.$app.isErrorReportingAvailable
                    ? _c("ErrorInfoModalButton", {
                        staticClass:
                          "bg-red-200 text-red-800 mb-2 desktop:mr-2 desktop:mb-0",
                        attrs: {
                          icon: "bug",
                          action: _vm.sentryId
                            ? "View report ID"
                            : "Send error report"
                        },
                        on: { click: _vm.report }
                      })
                    : _vm._e(),
                  _c("ErrorInfoModalButton", {
                    staticClass: "bg-red-200 text-red-800 desktop:mr-2",
                    attrs: {
                      icon: "github",
                      action: "report in GitHub",
                      url: _vm.githubReportUrl
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("pre", {
            staticClass:
              "p-4 h-full text-xs text-red-900 bg-white-overlay overflow-auto",
            domProps: { textContent: _vm._s(_vm.stackTrace) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }